export enum BusinessHubspotRole {
    B2B_ACCOUNT_OWNER = "persona_1",
    B2B_CLINICIAN = "persona_2",
    // B2B_PARENT= "B2B Parent",
    B2B_STUDENT= "persona_3",
    B2C_CLINICIAN = "persona_4",
    // B2C_PARENT= "B2C Parent",
    B2C_STUDENT= "persona_5",
    B2B_TEACHER= "persona_6",
    // ADMIN = "ADMIN"
}